import api from '../../../services/api'

export const getDailyLogs = (logOn) => api.get('/daily-logs', { params: { logOn } })
export const createDailyLog = (payload) => api.post('/daily-logs', payload)
export const updateDailyLog = (dailyLogId, payload) => api.put(`/daily-logs/${dailyLogId}`, payload)
export const deleteDailyLog = (dailyLogId) => api.delete(`/daily-logs/${dailyLogId}`)
export const getDailyLogTypes = () => api.get('/daily-logs/types')
export const getDailyLogOns = (params) => api.get('/daily-logs/log-ons', { params })
export const getFocusMetrics = (params) => api.get('/daily-logs/analytics/focus/metrics', { params })
export const getFocusSeries = (params) => api.get('/daily-logs/analytics/focus/series', { params })
export const getTimeUsageRates = (params) => api.get(
  '/daily-logs/analytics/analytics/time-usage-rates',
  { params },
)
